export default __webpack_public_path__ + "static/media/ShMunAnimatedGif.d2d73b04.gif";